import { types } from "mobx-state-tree";
import { parseSectionPath } from "../../../shared/shared";
import { DocumentContentModel } from "../document/document-content";
import { SupportModel } from "./support";
import { each } from "lodash";
export const kAllSectionType = "all";
const kAllSectionInfo = { initials: "*", title: "All" };
export const kUnknownSectionType = "unknown";
const kUnknownSectionInfo = { initials: "?", title: "Unknown" };
const gSectionInfoMap = { [kAllSectionType]: kAllSectionInfo };
export function registerSectionInfo(sectionInfoMap) {
    // regular content and teacher guide are two separate units, so we merge them into a single map
    // teacher guide section types should be unique from regular content; we don't replace existing entries
    each(sectionInfoMap, (sectionInfo, sectionType) => {
        if (!gSectionInfoMap[sectionType]) {
            gSectionInfoMap[sectionType] = sectionInfo;
        }
        // else {
        //   console.warn("registerSectionInfo skipping redundant assignment of section type:",
        //               `${sectionType} "${sectionInfo.title}"`);
        // }
    });
}
function getSectionInfo(type) {
    return gSectionInfoMap && gSectionInfoMap[type] || kUnknownSectionInfo;
}
export function getSectionInitials(type) {
    return getSectionInfo(type).initials;
}
export function getSectionTitle(type) {
    return getSectionInfo(type).title;
}
export function getSectionPlaceholder(type) {
    return getSectionInfo(type).placeholder;
}
export function getMaxInitialsLength(sectionInfoMap) {
    const map = sectionInfoMap || gSectionInfoMap;
    let max = 0;
    for (const key of Object.keys(map)) {
        if (key !== kAllSectionType) {
            max = Math.max(max, map[key].initials.length);
        }
    }
    return max;
}
export const SectionModel = types
    .model("Section", {
    type: types.string, // sectionId corresponding to entry in unit
    // list of features to be disabled for this section
    // currently unused as features are only disabled at the problem level
    disabled: types.array(types.string),
    content: types.maybe(DocumentContentModel),
    supports: types.array(SupportModel),
})
    .volatile(self => ({
    realParent: undefined
}))
    .views(self => {
    return {
        get initials() {
            return getSectionInitials(self.type);
        },
        get title() {
            return getSectionTitle(self.type);
        },
        get placeholder() {
            return getSectionPlaceholder(self.type);
        }
    };
})
    .actions(self => ({
    setRealParent(parent) {
        self.realParent = parent;
    }
}));
export function findSectionIndex(sections, fullPath) {
    if (fullPath !== undefined) {
        const [, , , , sectionSelected] = parseSectionPath(fullPath) || [];
        const index = sections.findIndex((section) => section.type === sectionSelected);
        return index;
    }
    else {
        return 0;
    }
}
//# sourceMappingURL=data:application/json;base64,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